import { render, staticRenderFns } from "./FetchExpress.vue?vue&type=template&id=098ab6bd&scoped=true&"
import script from "./FetchExpress.vue?vue&type=script&lang=js&"
export * from "./FetchExpress.vue?vue&type=script&lang=js&"
import style0 from "./FetchExpress.vue?vue&type=style&index=0&id=098ab6bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098ab6bd",
  null
  
)

export default component.exports